export default function AvisoLegal() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-6">Aviso Legal</h1>

      <p className="mb-4">
        Este sitio web es operado por [Nombre de tu empresa]. Toda la información
        contenida es propiedad de la empresa y no puede ser reproducida sin autorización.
      </p>

      <h2 className="text-xl font-semibold mb-2">Responsabilidad</h2>
      <p className="mb-4">
        No somos responsables por daños ocasionados por el uso incorrecto del sitio
        o fallas externas no atribuibles a nosotros.
      </p>

      <h2 className="text-xl font-semibold mb-2">Propiedad intelectual</h2>
      <p>
        Todas las imágenes, textos y material gráfico están protegidos por derechos de autor.
      </p>
    </div>
  );
}
